import React from "react";
import {
    Typography, Dialog, DialogTitle, DialogContent, DialogActions, Button,
} from "@mui/material";
import { UploadedFileListProps, AddFundModeType } from "../../../types/types"
import expStyles from "./FundExpenseDetail.module.scss"
import FileUpload from "../../../components/FileUpload/FileUpload"

import {
    CustomDataTable
} from "../../../components/CommnTable/CustomDataTable";


const AddReceiptModel = ({ setOpen,open ,type ,data, file, columns, handleUploadReceipt, id,ViewReceiptColumn }: AddFundModeType) => (
    <Dialog onClose={() => setOpen(false)}
        fullWidth
        maxWidth="md"
        open={open} className={expStyles.customDialog}>
        <DialogTitle>Receipts Preview</DialogTitle>
        <DialogContent
            sx={{
                overflowY: 'auto',
            }}
        >
            {type === "view" ?
                <CustomDataTable<any>
                    data={data.receipt_url}
                    columns={ViewReceiptColumn}
                    globalFilterEnabled={false}
                    tableTitle="Student Payment History"
                    rowCount={file.length}
                /> :
                type != 'view' &&
                    file.length === 0 ? (
                    <Typography mt={2} color="text.secondary">
                        No files uploaded yet.
                    </Typography>
                ) : (
                    <CustomDataTable<UploadedFileListProps>
                        data={file}
                        columns={columns}
                        globalFilterEnabled={false}
                        tableTitle="Student Payment History"
                        rowCount={file.length}
                    />
                )}
        </DialogContent>
        <DialogActions>
           {type != "view" && <FileUpload onFileSelect={handleUploadReceipt} />}
            <Button variant="contained" color="error" onClick={() => setOpen(false)}>Close</Button>
        </DialogActions>
    </Dialog>
)

export default AddReceiptModel